<template>
    <v-app>
        <v-toolbar fixed app :clipped-left="false" extended>
        </v-toolbar>
        <div id="header-image">
            <img :src="logo"/>
        </div>

        <v-content>
            <v-container fluid fill-height>
                <v-layout row full-width align-center justify-center>
                    <v-flex xs-12 v-if="!free">
                        <v-text-field v-model="cellphone" type="number" label="Cellphone Number"></v-text-field>
                        <v-text-field v-model="password" type="password" label="Password"></v-text-field>
                        <v-checkbox label="Remember Me" v-model="remember"></v-checkbox>
                        <v-btn class="vas-btn" block @click="login">Login</v-btn>

                        <div class="text-xs-center">
                            <v-btn flat :to="{name: 'unauthenticated.forgot'}" class="forgot-pwd-btn">
                                Forgot password?
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs-12 v-if="free">
                        <v-text-field v-model="name" type="text" label="Your Name"></v-text-field>
                        <v-text-field v-model="cellphone" type="number" label="Cellphone Number"></v-text-field>

                        <v-checkbox label="Remember Me" v-model="remember"></v-checkbox>
                        <v-btn class="vas-btn" block @click="login">Login</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>

        <v-footer app v-if="!free">
            <div style="text-align: center; justify-content: center; width: 100%">
                <router-link :to="{name: 'unauthenticated.signup'}" class="signup-anchor">
                    Don't have an account? <span class="signup-link">Sign Up</span>
                </router-link>
            </div>
        </v-footer>
        <v-dialog v-model="showError" :persistent="true">
            <v-card>
                <v-card-text>
                    {{ errorMessage }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="showError = false">
                        Okay
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
    import vas from "@/lib/VASClient"
    import {mapState} from 'vuex'

    var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

    export default {
        data() {
            return {
                cellphone: '',
                password: '',
                logo: require('../../../variants/' + BUILD_VARIANT + '/logo.png'),
                showError: false,
                errorMessage: '',
                remember: false,
                free: config.registration.free,
                name: ''
            }
        },
        methods: {
            login() {
                var self = this;

                Loading.show("Logging in");
                if (this.free) {
                    var self = this;
                    vas.freeLogin(this.cellphone, this.name).then(function (response) {
                        if (response.status) {
                            self.$store.commit('auth/login', {
                                user: response.user,
                                remember: self.remember,
                                name: self.name
                            });
                            self.$router.push('/dashboard')
                        } else {
                            self.showError = true;
                            self.errorMessage = response.msg;
                        }

                        Loading.hide();
                    }).catch(function (response) {
                        self.showError = true;
                        self.errorMessage = 'An error has occurred. Please try again later';
                        // self.errorMessage = JSON.stringify(response);

                        Loading.hide();
                    });
                } else {
                    vas.login(this.cellphone, this.password).then(function (response) {
                        if (response.status) {
                            self.$store.commit('auth/login', {
                                user: response.user,
                                remember: self.remember
                            });

                            self.$router.push('/dashboard')
                        } else {
                            self.showError = true;
                            self.errorMessage = response.msg;
                        }

                        Loading.hide();
                    }).catch(function (response) {
                        self.showError = true;
                        self.errorMessage = 'An error has occurred. Please try again later';
                        // self.errorMessage = JSON.stringify(response);

                        Loading.hide();
                    });
                }
            }
        },
        computed: {
            ...mapState(
                ['auth']
            )
        },
        created() {
            var remember = localStorage.getItem('remember');
            var name = localStorage.getItem('name');

            if (typeof remember !== 'undefined' && remember != null && remember != '' && this.auth.user != null) {
                this.$router.push('/dashboard');
            } else {
                this.remember = false;
                this.cellphone = '';
                this.name = '';
            }
        }
    }
</script>
